// src/features/tools/ToolsService.js 
import { customFetch } from '../../customFetch';
import { TOOLS, ASSIGNED_TOOLS } from '../../utils/URLS';

const ToolsService = {
  // Obtener todos los equipos
  async getAllTools() {
    try {
      const response = await customFetch(TOOLS.LIST, {});
      return await response.json();
    } catch (error) {
      console.error('Error en getAllTools:', error);
      throw error;
    }
  },


  async getAllAssignedTools() {
    try {
      console.log('🔍 Llamando a getAllAssignedTools con URL:', ASSIGNED_TOOLS.LIST);
      const response = await customFetch(ASSIGNED_TOOLS.LIST, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('✅ Datos de herramientas asignadas recibidos:', data);
      return data;
    } catch (error) {
      console.error('❌ Error en getAllAssignedTools:', error);
      throw error;
    }
  },

  // Filtrar equipos por criterios
  async filterTools(params) {
    try {
      const url = params && params.length > 0 
        ? `${TOOLS.SEARCH}?${params}` 
        : TOOLS.LIST;
      
      const response = await customFetch(url, {});
      return await response.json();
    } catch (error) {
      console.error('Error en filterTools:', error);
      throw error;
    }
  },

  // Obtener un equipo específico
  async getTool(id) {
    try {
      const response = await customFetch(`${TOOLS.LIST}${id}`, {});
      return await response.json();
    } catch (error) {
      console.error(`Error en getTool (ID: ${id}):`, error);
      throw error;
    }
  },

  // Crear un nuevo equipo
  async createTool(toolData) {
    try {
      const response = await customFetch(TOOLS.CREATE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(toolData)
      });
      
      return await response.json();
    } catch (error) {
      console.error('Error en createTool:', error);
      throw error;
    }
  },

  // Actualizar un equipo existente
  async updateTool(id, toolData) {
    try {
      const response = await customFetch(`${TOOLS.LIST}${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(toolData)
      });
      
      return await response.json();
    } catch (error) {
      console.error(`Error en updateTool (ID: ${id}):`, error);
      throw error;
    }
  },

  // Eliminar un equipo
  async deleteTool(id) {
    try {
      const response = await customFetch(`${TOOLS.LIST}${id}`, {
        method: 'DELETE'
      });
      
      return await response.json();
    } catch (error) {
      console.error(`Error en deleteTool (ID: ${id}):`, error);
      throw error;
    }
  },

  // Obtener equipos retirados
  async getRetiredTools(id) {
    try {
      const response = await customFetch(`${TOOLS.LIST}${id}/retired`, {});
      const data = await response.json();
      
      // Mapear los datos según la estructura esperada
      if (response.status === 200 || response.status === 201) {
        if (data && data[0]) {
          const tooltype = {
            id: data[0].id, 
            type: data[0].type, 
            name: data[0].name, 
            quantity: data[0].quantity
          };
          
          const tools = data[0].assigned.map((retiredTool) => {
            return {...retiredTool, tool: tooltype};
          });
          
          return {
            statusCode: response.status,
            data: tools
          };
        }
      }
      
      return {
        statusCode: response.status,
        data: []
      };
    } catch (error) {
      console.error(`Error en getRetiredTools (ID: ${id}):`, error);
      throw error;
    }
  },

  // Obtener información de un equipo asignado
  async getAssignedTool(id) {
    try {
      const response = await customFetch(`${ASSIGNED_TOOLS.LIST}${id}`, {});
      const data = await response.json();
      
      if (response.status === 200 || response.status === 201) {
        // Obtener historial del equipo
        const historyResponse = await customFetch(`${ASSIGNED_TOOLS.LIST}${id}/history`, {});
        const historyData = await historyResponse.json();
        
        return {
          statusCode: response.status,
          data: {...data, history: historyData}
        };
      }
      
      return {
        statusCode: response.status,
        data
      };
    } catch (error) {
      console.error(`Error en getAssignedTool (ID: ${id}):`, error);
      throw error;
    }
  },

  // Asignar equipo a una persona
  async assignToolToPerson(personId, toolData) {
    try {
      const response = await customFetch(`${TOOLS.ASSIGN_TO_PERSON(personId)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(toolData)
      });
      
      return await response.json();
    } catch (error) {
      console.error(`Error en assignToolToPerson (PersonID: ${personId}):`, error);
      throw error;
    }
  },

  // Reasignar equipo a una obra
  async reassignToolToWork(workId, toolId) {
    try {
      const response = await customFetch(`${ASSIGNED_TOOLS.LIST}${toolId}/reassign/work/${workId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
      });
      
      const data = await response.json();
      
      return {
        statusCode: response.status,
        data
      };
    } catch (error) {
      console.error(`Error en reassignToolToWork (WorkID: ${workId}, ToolID: ${toolId}):`, error);
      throw error;
    }
  },

  // Reasignar equipo a una persona
  async reassignToolToPerson(personId, toolId) {
    try {
      const response = await customFetch(`${ASSIGNED_TOOLS.LIST}${toolId}/reassign/person/${personId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
      });
      
      const data = await response.json();
      
      return {
        statusCode: response.status,
        data
      };
    } catch (error) {
      console.error(`Error en reassignToolToPerson (PersonID: ${personId}, ToolID: ${toolId}):`, error);
      throw error;
    }
  },

  // Eliminar un equipo asignado
  async deleteAssignedTool(toolId) {
    try {
      const response = await customFetch(`${ASSIGNED_TOOLS.LIST}${toolId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' }
      });
      
      const data = await response.json();
      
      return {
        statusCode: response.status,
        data
      };
    } catch (error) {
      console.error(`Error en deleteAssignedTool (ToolID: ${toolId}):`, error);
      throw error;
    }
  },

  // Retirar un equipo asignado
  async retireAssignedTool(toolId) {
    try {
      const response = await customFetch(`${ASSIGNED_TOOLS.LIST}${toolId}/retire`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
      });
      
      const data = await response.json();
      
      return {
        statusCode: response.status,
        data
      };
    } catch (error) {
      console.error(`Error en retireAssignedTool (ToolID: ${toolId}):`, error);
      throw error;
    }
  },

  // Desasignar equipo (devolverlo al stock)
  async unassignTool(toolId) {
    try {
      const response = await customFetch(`${ASSIGNED_TOOLS.LIST}${toolId}/unassign`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
      });
      
      const data = await response.json();
      
      return {
        statusCode: response.status,
        data
      };
    } catch (error) {
      console.error(`Error en unassignTool (ToolID: ${toolId}):`, error);
      throw error;
    }
  },

  // Funciones de utilidad para transformar datos
  transformDataByType(data) {
    // Agrupar herramientas por tipo
    const groups = data
      .map(tool => tool.tool.type)
      .filter((item, index, array) => array.indexOf(item) === index);
    
    return groups.map(group => ({
      toolType: group,
      values: data.filter(element => element.tool.type === group)
    }));
  },

  groupByTool(data) {
    // Agrupar herramientas por ID
    const groups = data
      .map(tool => tool.tool.id)
      .filter((item, index, array) => array.indexOf(item) === index);
    
    return groups.map(group => {
      const groupedItems = data.filter(element => element.tool.id === group && !element.deletedDate);
      const deletedItems = data.filter(element => element.tool.id === group && element.deletedDate);
      
      return {
        toolid: group,
        checked: 'false',
        ToolName: groupedItems[0]?.tool.name || 'Desconocido',
        values: groupedItems,
        deletedValues: deletedItems
      };
    });
  }
  

};

export default ToolsService;